import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { type ISnippet } from '@principle-theorem/editor';
import { AbstractResolver } from '@principle-theorem/ng-shared';
import { Brand, Staffer } from '@principle-theorem/principle-core';
import {
  type IBrand,
  type IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { getDoc$, type WithRef } from '@principle-theorem/shared';
import { type Observable, of } from 'rxjs';

@Injectable()
export class SnippetResolverService extends AbstractResolver<
  WithRef<ISnippet>
> {
  getItemById(
    id: string,
    route: ActivatedRouteSnapshot
  ): Observable<WithRef<ISnippet> | undefined> {
    const staffer: WithRef<IStaffer> | undefined = this._findInheritedRouteData(
      route,
      'staffer'
    );
    const brand: WithRef<IBrand> | undefined = this._findInheritedRouteData(
      route,
      'brand'
    );

    if (staffer) {
      const collection = Staffer.snippetCol(staffer);
      return getDoc$<ISnippet>(collection, id);
    }

    if (!brand) {
      return of(undefined);
    }
    const collection = Brand.snippetCol(brand);
    return getDoc$<ISnippet>(collection, id);
  }
}
